import "./InstructionsPage.css"
import { useNavigate } from "react-router-dom"
import { useState, useEffect } from 'react';

export default function InstructionsPage() {
    const navigate = useNavigate()

    function handleClick() {
        navigate("/")
    }


    return (
        <section className="instructions-page-ctr">
            <div className="introduction">
                <h2>ClinCase.AI</h2>
        
                    <h4>Practice clinical reasoning with artificial intelligence</h4>
            </div>
            <div className="instructions">
                <ul>
                    <li>
                        You will be presented with a three part clinical case. During each phase, you will rank the DDx and provide your rationale. 
                    </li>
                    <li>
                        You will have the opportunity to update your DDx ranking and rationale based on new clinical data in phase 2 and then again in phase 3.
                        </li>
                        <li>
                        After your initial submission in each phase, you will have the chance to ask for help from an AI assistant (GPT<label style={{ fontFamily: "arial"}}>-4</label><small>o</small> from OpenAI) and to reorder your DDx ranking and rationale as needed.
                            </li>
                    <li>
                        The goal is not necsesarily to get a "right answer" for the DDx ranking in each phase. The process of diagnostic reasoning and role of integrating AI will be discussed during the breakout sessions in class.
                    </li>
                    <li>
                         In the survey after the case, please reflect on how the use of AI influenced your clinical reasoning.
                    </li>
                    <li>
                       For reference during the session in class, you can access your DDx rankings, rationale, and AI interactions on the <strong>My Data</strong> page after you have completed the case.
                    </li>
                </ul>
            </div>
             <br></br>
            <button onClick={handleClick}>Go to Cases</button>
            <br></br>
            {/* <br></br> */}

            <div className="introduction">
    
                    <div className="instructions">

                    <ul>
                    <h3 className="left-align-instructions">FAQs</h3>
                    <li>
                    <strong>What email should I use to create a new account?</strong> &nbsp; Please use your TUSM email address and enter your full name. Your TUSM credentials will not automatically be linked to this web app--you must create your account and set a password the first time you access this website.
                    </li>
                    <li>
                    <strong>What if I forget my password?</strong> &nbsp; This pilot verison of the web app does not yet have a password reset feature linked to your email on file. If you are locked out of your account because you forgot your password, please create a new temporary account with a separate email address so you can complete the exercise. Later, you can notify Dr. Hayden by email (robert.hayden@tufts.edu) so your original account can be reset. Thanks for your patience.
                    </li>
                    <li>
                    <strong>Why are we using this pilot web app?</strong> &nbsp; This web application has been custom-built by your TUSM faculty to facilitate a standardized clinical reasoning experience with integrated AI that will lend itself to further discussion during the in-class ICR session.
                    </li>
                    <li>
                    <strong>Can I use other AI tools aside from the built-in chatbot?</strong> &nbsp; Please limit your use of AI to the chatbot that has been integrated directly into this web app. There will be many opportunities to use other AI resources for clinical reasoning throughout your training at TUSM.
                    </li>
                    <li>
                    <strong>What if I have questions or find issues with the app?</strong> &nbsp; Please reach out to Dr. Hayden by email (robert.hayden@tufts.edu)
                    </li>
                    </ul>
            </div>
            </div>


        </section>
    )
}